(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eltobert-studio-discovery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (!root || root.dataset.ebStudioDiscoveryReady === 'true') return;
      root.dataset.ebStudioDiscoveryReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-eb-sd-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-eb-sd-panel]'));

      const activePanel = () => panels.find((panel) => !panel.hidden);

      const activate = (tab, moveFocus = false) => {
        const target = tab.dataset.ebSdTab;
        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.ebSdPanel === target;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (moveFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.tabIndex = tab.classList.contains('is-active') ? 0 : -1;
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + direction + tabs.length) % tabs.length;
          activate(tabs[nextIndex], true);
        });
      });

      const scrollActiveRail = (direction) => {
        const rail = activePanel()?.querySelector('[data-eb-sd-rail]');
        const card = rail?.querySelector('[data-eb-sd-product]');
        if (!rail || !card) return;
        const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0);
        rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };

      root.querySelector('[data-eb-sd-prev]')?.addEventListener('click', () => scrollActiveRail(-1));
      root.querySelector('[data-eb-sd-next]')?.addEventListener('click', () => scrollActiveRail(1));

      panels.forEach((panel) => {
        const rail = panel.querySelector('[data-eb-sd-rail]');
        const dots = panel.querySelector('[data-eb-sd-dots]');
        const cards = Array.from(panel.querySelectorAll('[data-eb-sd-product]'));
        if (!rail || !dots || cards.length < 2) return;

        cards.forEach((card, index) => {
          const dot = document.createElement('span');
          dot.className = `eb-sd__dot${index === 0 ? ' is-active' : ''}`;
          dots.appendChild(dot);
        });

        let ticking = false;
        rail.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const firstCard = cards[0];
            const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0);
            const step = firstCard.getBoundingClientRect().width + gap;
            const activeIndex = step > 0 ? Math.round(rail.scrollLeft / step) : 0;
            Array.from(dots.children).forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
            ticking = false;
          });
        }, { passive: true });
      });
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll('[data-eb-studio-discovery]').forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function initialiseHeroSlider(slider) {
    if (!slider || slider.dataset.sliderInitialised === 'true') return;

    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));

    if (slides.length === 0) return;

    slider.dataset.sliderInitialised = 'true';

    const previousButton = slider.querySelector('[data-hero-slider-previous]');
    const nextButton = slider.querySelector('[data-hero-slider-next]');
    const dotsContainer = slider.querySelector('[data-hero-slider-dots]');

    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const pauseOnHover = slider.dataset.pauseOnHover === 'true';
    const speed = Number(slider.dataset.speed) || 5000;

    let currentSlide = 0;
    let autoplayTimer = null;
    let touchStartX = 0;
    let touchEndX = 0;

    slides.forEach((slide) => {
      slide.classList.remove('is-active', 'is-previous');
      slide.setAttribute('aria-hidden', 'true');
    });

    slides[0].classList.add('is-active');
    slides[0].setAttribute('aria-hidden', 'false');

    function createDots() {
      if (!dotsContainer) return;

      dotsContainer.innerHTML = '';

      slides.forEach((slide, index) => {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'hero-slider__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);

        if (index === 0) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-current', 'true');
        }

        dot.addEventListener('click', () => {
          showSlide(index);
          restartAutoplay();
        });

        dotsContainer.appendChild(dot);
      });
    }

    function updateDots() {
      if (!dotsContainer) return;

      const dots = dotsContainer.querySelectorAll('.hero-slider__dot');

      dots.forEach((dot, index) => {
        const active = index === currentSlide;

        dot.classList.toggle('is-active', active);

        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function showSlide(newIndex) {
      if (slides.length <= 1) return;

      const oldIndex = currentSlide;

      if (newIndex < 0) {
        newIndex = slides.length - 1;
      }

      if (newIndex >= slides.length) {
        newIndex = 0;
      }

      slides.forEach((slide) => {
        slide.classList.remove('is-active', 'is-previous');
        slide.setAttribute('aria-hidden', 'true');
      });

      slides[oldIndex].classList.add('is-previous');
      slides[newIndex].classList.add('is-active');
      slides[newIndex].setAttribute('aria-hidden', 'false');

      currentSlide = newIndex;
      updateDots();
    }

    function nextSlide() {
      showSlide(currentSlide + 1);
    }

    function previousSlide() {
      showSlide(currentSlide - 1);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length <= 1) return;

      stopAutoplay();
      autoplayTimer = window.setInterval(nextSlide, speed);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (previousButton) {
      previousButton.addEventListener('click', () => {
        previousSlide();
        restartAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        nextSlide();
        restartAutoplay();
      });
    }

    if (pauseOnHover) {
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
    }

    let touchStartY = 0;
let touchCurrentX = 0;
let touchCurrentY = 0;

slider.addEventListener(
  'touchstart',
  (event) => {
    const touch = event.touches[0];

    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    touchCurrentX = touchStartX;
    touchCurrentY = touchStartY;

    stopAutoplay();
  },
  { passive: true }
);

slider.addEventListener(
  'touchmove',
  (event) => {
    const touch = event.touches[0];

    touchCurrentX = touch.clientX;
    touchCurrentY = touch.clientY;
  },
  { passive: true }
);

slider.addEventListener(
  'touchend',
  () => {
    const horizontalDistance = touchCurrentX - touchStartX;
    const verticalDistance = touchCurrentY - touchStartY;

    const isHorizontalSwipe =
      Math.abs(horizontalDistance) >= 50 &&
      Math.abs(horizontalDistance) > Math.abs(verticalDistance);

    if (isHorizontalSwipe) {
      if (horizontalDistance < 0) {
        nextSlide();
      } else {
        previousSlide();
      }
    }

    restartAutoplay();
  },
  { passive: true }
);

    createDots();
    startAutoplay();
  }

  function initialiseAllHeroSliders(container = document) {
    container.querySelectorAll('[data-hero-slider]').forEach(initialiseHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseAllHeroSliders();
    });
  } else {
    initialiseAllHeroSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAllHeroSliders(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
